import React, { useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { ChartDataset } from '../../model/ChartDataset';
import { getTooltip } from '../../model/Chart';
Chart.register(...registerables);

const DoughnutChart = ({ datasets, labels }: Props) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstanceRef = useRef<any>(null);

  useEffect(() => {
    chartInstanceRef.current = chartRef.current && new Chart(chartRef.current, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        responsive: true,
        animation: false,
        cutout: '70%',
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: getTooltip()
        }
      }
    });
    return () => {
      chartInstanceRef.current?.destroy();
      chartInstanceRef.current = null;
    };
  }, [ datasets, labels ]);

  return (
    <div className="d-flex h-100 align-items-center">
      <canvas className="z-1" ref={chartRef}></canvas>
    </div>
  );
}

interface Props {
  datasets: ChartDataset[],
  labels: string[]
}

export { DoughnutChart };